import React, { FC } from 'react';
import './TRP.scss';
import coalesce from '../../utils/coalesce';

type Props = {
  className?: string;
  showRegistered?: boolean;
};

const TRP: FC<Props> = ({ className, showRegistered }) => (
  <span className={`${coalesce(className, '')} trp`}>
    T.Rowe Price{showRegistered ? <span className="reg">®</span> : ''}
  </span>
);

export default TRP;
